import { type ComputedRef, ref, watch } from 'vue';
import type { Props, SearcherByKey } from '../types';

/**
 * Создание и управление реактивными переменными для сравнения
 *
 * @param props - входные props компонента
 * @param searcherByKey - Map ПС (реактивная)
 * @param allRegionsIndexes - Все доступные индексы регионов (реактивная)
 */
export const useCompare = (props: Props, searcherByKey: ComputedRef<SearcherByKey>, allRegionsIndexes: ComputedRef<Set<number>>) => {
	/**
	 * Индексы регионов/ПС в сравнение
	 */
	const regionsIndexes = ref<number[]>([]);

	/**
	 * Загрузка индексов регионов для сравнения
	 *
	 * Если в modelValue передано несколько регионов, они будут установлены как выбранные для сравнения
	 */
	const compareLoad = () => {
		if (props.onlySearcher && searcherByKey.value) {
			regionsIndexes.value = Array.from(searcherByKey.value.keys());

			return;
		}

		let regionsIndexesSaved: Props['modelValue'] = [];

		if (props.modelValue.length > 1) {
			regionsIndexesSaved = [...props.modelValue];
		} else {
			try {
				// загрузить индексы регионов, если они были сохранены
				regionsIndexesSaved = JSON.parse(
					localStorage.getItem('ui:project:regionSelector' + props.projectId + ':regionsIndexes') as string,
				) ?? [];
			} catch (e) {

			}
		}

		// убрать из сравнения регионы, которых нет в props.searchers
		if (regionsIndexesSaved.length) {
			regionsIndexesSaved = regionsIndexesSaved.filter((regionIndex) => {
				return allRegionsIndexes.value.has(regionIndex);
			});
		}

		// если не сохранено ни одного региона, выбрать все регионы проекта
		if (!regionsIndexesSaved.length) {
			regionsIndexesSaved = Array.from(allRegionsIndexes.value);
		}

		regionsIndexes.value = [...regionsIndexesSaved];
	};

	/**
	 * Сохранение выбранных регионов
	 */
	const compareSave = () => {
		if (regionsIndexes.value.length) {
			localStorage.setItem('ui:project:regionSelector:' + props.projectId + ':regionsIndexes', JSON.stringify(regionsIndexes.value));
		} else {
			localStorage.removeItem('ui:project:regionSelector:' + props.projectId + ':regionsIndexes');
		}
	};

	watch(regionsIndexes, () => {
		compareSave();
	});

	if (props.addCompare) {
		// if (props.compareRegionsIndexes?.length) {
		// 	compareRegionsIndexes.value = [...props.compareRegionsIndexes];
		// } else {
		// 	compareLoad();
		// }

		compareLoad();
	}

	return {
		regionsIndexes,
	};
};
